export const environment = {
  production: false,
  authority: 'www.test.salesforce.com',
  redirectUrl: 'https://sit3.selfservice.mypage.manulife.co.jp',
  authWellknownEndpointUrl: 'https://cws-r3.manulife.co.jp',
  clientId: '3MVG9KAEr0ABaqiohxfQdw9yBxRqEBX4vKA_NUCCdOsTdJCQ1LNk1I8Q1q._rXPkYRe7fRKkWuwZhR7j55EcN',
  scope: 'openid api',
  responseType: 'code',
};


export const common_urls = {
  // bffBaseUrl: 'https://internal.sit.apps.manulife.co.jp/ext/cws/bff/api/v1',
  // bffBaseUrl: 'https://jp-sit1-api.ap.manulife.com/ext/cws/bff/api/v1',
  bffBaseUrl: 'https://sit.apps.manulife.co.jp/ext/sit5/cws/bff/api/v1',
  cwsBaseUrl: 'https://cws-r3.manulife.co.jp',
  surveyUrl: '', // not in use
  footerNotesUrl: 'https://cws-r3.manulife.co.jp/cws/resource/1693483917000',
  callCenterUrl: 'https://www.manulife.co.jp/ja/individual/contact.html',
  footerTermsOfUseUrl: 'https://cws-r3.manulife.co.jp/cws/resource/1726550001000',
  oodMenuItemsUrl: 'https://sit.apps.manulife.co.jp/ext/sit5/cws/bff/api/v1',
  eShishobakoRedirectUrl: "https://www.manulife.co.jp/ja/policyholder/procedure/e-shishobako/use.html",
  adobeAnalyticsUrl: 'https://assets.adobedtm.com/b84dbf01908c/ea9ea5ad8be8/launch-b7a8bf727ff2-staging.min.js',
  newRelicUrl: '/assets/newRelic/Asia-JP-CWS-NG-UAT.js',
  bffInternalUrl: 'https://sit.apps.manulife.co.jp/ext/sit5/cws/bff/api/survey/v1'
}

export const common_url_sur = {
  bffBaseSurUrl: 'https://sit.apps.manulife.co.jp/ext/cws5-sur/bff/api/v1/',
  cwsLoginUrl: "https://cws-r3.manulife.co.jp/cws/?cws=1",
  publicKey: `I6yYGTawjAAIVS7Bzv0KUdHjmL02xODrGSJm1rQAGGQ=`
}


export const common_urls_gasa = {
  bffBaseUrl: 'https://sit.apps.manulife.co.jp/ext/sit5/cws/bff/api/v1/gasa',
  cwsBaseUrl: 'https://cws-r3.manulife.co.jp',
}

export const ereport_urls = {
  bffBaseEreportUrl: 'https://sit.apps.manulife.co.jp/ext/sit5-fraereport/cws/bff/api/v1'
}

export const common_urls_c360 = {
  bffBaseUrl: 'https://sit.apps.manulife.co.jp/ext/cws5-c360/bff/api/v1'
}

export const stop_mailing_certificates_url = {
  bffBaseUrl: 'https://sit.apps.manulife.co.jp/ext/sit5/cws/bff/api/v1',
  cwsBaseUrl: 'https://cws-r3.manulife.co.jp',
  errorPage: '/error_page'
}

export const common_urls_mobile_registration = {
  bffBaseUrl: 'https://sit.apps.manulife.co.jp/ext/cws5-sur/bff/api/v1',
  cwsBaseUrl: 'https://cws-r3.manulife.co.jp',
  expireUrl: 'https://cws-r3.manulife.co.jp/auth'
}

export const stp_cws_urls = {
  baseUrl: 'https://sit.apps.manulife.co.jp/ext/sit5/cws-sur/bff/api/v1',
  cwsLoginUrl: "https://cws-r3.manulife.co.jp/auth",
  publicKey: 'I6yYGTawjAAIVS7Bzv0KUdHjmL02xODrGSJm1rQAGGQ=',
  bffBaseUrl: 'https://sit.apps.manulife.co.jp/ext/sit5/cws/bff/stp/api/v1',
  oodMenuItemsUrl: 'https://sit.apps.manulife.co.jp/ext/sit5/cws/bff/api/v1/'
}

export const tnps_survey_config = {
    surveyAlertWaitTime: 60000,
    bffBaseUrl: 'https://sit.apps.manulife.co.jp/ext/sit5/cws/bff/api/v1',
    surveyUrl: 'https://survey4.medallia.com/?manulife-jp-cws-uat&tranID=MLJ_CWS_DEFAULT&lng=ja&tp=CWS&subTP=GASA_POLICY_INQUIRY&region=JP&devCycle=1%27'
  }

export const family_registration_inquiry = {
    familyInquiryHtml: 'https://www.manulife.co.jp/ja/policyholder/procedure/procedure-attorney.html'
}

export const common_urls_credit_card = {
  // bffBaseUrl: 'https://jp-dev-api.ap.manulife.com/ext/cws-ang/bff/api/v1',
     bffBaseUrl: 'https://sit.apps.manulife.co.jp/ext/sit5/cws2-ang/bff/api/v1',
}

export const gmo_config = {
  gmoScriptUrl: 'https://stg.static.mul-pay.jp/ext/js/token.js',
  gmoShopId: 'tshop00006370'
}

export const common_urls_rp_surrender = {
  bffBaseUrl: 'https://sit.apps.manulife.co.jp/ext/sit5/cws/bff/api/v1/gasa',
  cwsBaseUrl: 'https://cws-r3.manulife.co.jp',
  rpBaseUrl: 'https://sit.apps.manulife.co.jp/ext/sit3/cws/bff/v1',
  myPageHomeUrl: 'https://cws-r3.manulife.co.jp/Home?from=auth'
}
export const common_urls_cws2 = {
  bffBaseUrl_cws2: 'https://sit.apps.manulife.co.jp/ext/sit5/cws2-ang/bff/api/v1',
  bffBaseUrl_mvp3: 'https://sit.apps.manulife.co.jp/ext/sit5/cws2-procedure/bff/api/v1/',
}

export const userid_change_config = {
    bffBaseUrl: 'https://sit.apps.manulife.co.jp/ext/sit5/cws/bff/api/v1',
    cwsLoginUrl: 'https://cws-r3.manulife.co.jp/cws/?cws=1'
}

export const feature_flags = {
  vocImplementation: false,
};

export const voc_config = {
  medallia_digital_formID: 6327,
};
